// Map Configuration Constants
export const MAP_CONFIG = {
  DEFAULT_CENTER: [77.1277, 28.6304], // Delhi
  DEFAULT_ZOOM: 14,
  STYLE_URL: 'https://tiles.openfreemap.org/styles/liberty',
  TILE_URL: '/tiles/{z}/{x}/{y}.png',
  MIN_ZOOM: 10,
  MAX_ZOOM: 18,
};

// POI Categories Configuration
// Based on database analysis: 3,367,701 total points with 438 distinct amenities, 829 shop types, 57 tourism types, 61 leisure types
// Order: Restaurant, Health, Schools, Banks, Malls, Gas Station
export const POI_CATEGORIES = {
  FOOD: {
    id: 'food',
    name: 'Restaurant',
    icon: '🍽️',
    className: 'food',
    amenities: ['restaurant', 'cafe', 'fast_food'],
  },
  HEALTH: {
    id: 'health',
    name: 'Health',
    icon: '🏥',
    className: 'health',
    amenities: ['hospital', 'clinic', 'pharmacy'],
  },
  EDUCATION: {
    id: 'education',
    name: 'Schools',
    icon: '🏫',
    className: 'education',
    amenities: ['school', 'college', 'university', 'kindergarten', 'library'],
  },
  FINANCE: {
    id: 'finance',
    name: 'Banks',
    icon: '🏦',
    className: 'finance',
    amenities: ['bank', 'atm'],
  },
  SHOPPING: {
    id: 'shopping',
    name: 'Malls',
    icon: '🏬',
    className: 'shopping',
    amenities: ['marketplace', 'mall', 'supermarket', 'convenience'],
  },
  SERVICES: {
    id: 'services',
    name: 'Gas Station',
    icon: '⛽',
    className: 'services',
    amenities: ['fuel'],
  },
  FACILITY: {
    id: 'facility',
    name: 'DLV Facilities',
    icon: '🏢',
    className: 'facility',
    amenities: ['facility'],
  },
  HOTEL: {
    id: 'hotel',
    name: 'Hotels',
    icon: '🏨',
    className: 'hotel',
    amenities: ['hotel'],
  },
  TEMPLE: {
    id: 'temple',
    name: 'Temples',
    icon: '🛕',
    className: 'temple',
    amenities: ['temple'],
  },
  CHURCH: {
    id: 'church',
    name: 'Churches',
    icon: '⛪',
    className: 'church',
    amenities: ['church'],
  },
  GURUDWARA: {
    id: 'gurudwara',
    name: 'Gurudwaras',
    icon: '🙏',
    className: 'gurudwara',
    amenities: ['gurudwara'],
  },
  MOSQUE: {
    id: 'mosque',
    name: 'Mosques',
    icon: '🕌',
    className: 'mosque',
    amenities: ['mosque'],
  },
  THEATRE: {
    id: 'theatre',
    name: 'Theatres',
    icon: '🎭',
    className: 'theatre',
    amenities: ['theatre'],
  },
  CASTLE: {
    id: 'castle',
    name: 'Forts',
    icon: '🏰',
    className: 'castle',
    amenities: ['castle'],
  },
  ATTRACTION: {
    id: 'attraction',
    name: 'Tourism',
    icon: '🎯',
    className: 'attraction',
    amenities: ['attraction'],
  },
};

// POI Icon Mappings
export const POI_ICONS = {
  // Health
  hospital: '🏥',
  clinic: '🏥',
  pharmacy: '💊',
  doctors: '👨‍⚕️',
  dentist: '🦷',
  health_post: '🏥',
  blood_bank: '🩸',
  // Education
  school: '🏫',
  college: '🎓',
  university: '🎓',
  kindergarten: '👶',
  library: '📚',
  // Finance
  bank: '🏦',
  atm: '🏧',
  bureau_de_change: '💱',
  // Food
  restaurant: '🍽️',
  cafe: '☕',
  fast_food: '🍔',
  bar: '🍺',
  pub: '🍻',
  food_court: '🍽️',
  // Shopping
  marketplace: '🏬',
  mall: '🏬',
  supermarket: '🛒',
  convenience: '🏪',
  clothes: '👕',
  electronics: '📱',
  jewelry: '💍',
  mobile_phone: '📱',
  beauty: '💄',
  hardware: '🔧',
  stationery: '📝',
  shoes: '👟',
  greengrocer: '🥬',
  tailor: '✂️',
  car: '🚗',
  grocery: '🛒',
  furniture: '🪑',
  bakery: '🥖',
  general: '🏪',
  hairdresser: '💇',
  medical_supply: '💊',
  // Services
  fuel: '⛽',
  police: '🚓',
  post_office: '📮',
  parking: '🅿️',
  charging_station: '🔌',
  car_wash: '🚿',
  toll: '🛣️',
  bus_station: '🚌',
  internet_cafe: '💻',
  toilets: '🚻',
  // Tourism
  hotel: '🏨',
  museum: '🏛️',
  attraction: '🎯',
  gallery: '🖼️',
  zoo: '🦁',
  viewpoint: '👁️',
  hostel: '🛏️',
  guest_house: '🏠',
  motel: '🏨',
  resort: '🏖️',
  theme_park: '🎢',
  aquarium: '🐠',
  artwork: '🎨',
  // Leisure
  park: '🌳',
  fitness_centre: '💪',
  sports_centre: '⚽',
  swimming_pool: '🏊',
  playground: '🛝',
  stadium: '🏟️',
  golf_course: '⛳',
  bowling_alley: '🎳',
  cinema: '🎬',
  theatre: '🎭',
  amusement_arcade: '🎮',
  // Religion
  place_of_worship: '🕌',

  // Other
  pothole: '⚠️',
  apartment: '🏢',
  default: '📍',
};

// FontAwesome Icon Mappings
export const FA_ICONS = {
  // Health
  hospital: 'fas fa-hospital',
  clinic: 'fas fa-clinic-medical',
  pharmacy: 'fas fa-pills',
  doctors: 'fas fa-user-doctor',
  dentist: 'fas fa-tooth',
  health_post: 'fas fa-clinic-medical',
  blood_bank: 'fas fa-droplet',
  // Education
  school: 'fas fa-school',
  college: 'fas fa-university',
  university: 'fas fa-university',
  kindergarten: 'fas fa-child',
  library: 'fas fa-book',
  // Finance
  bank: 'fas fa-building-columns',
  atm: 'fas fa-money-bill-wave',
  bureau_de_change: 'fas fa-money-bill-transfer',
  // Food
  restaurant: 'fas fa-utensils',
  cafe: 'fas fa-mug-hot',
  fast_food: 'fas fa-hamburger',
  bar: 'fas fa-martini-glass',
  pub: 'fas fa-beer-mug-empty',
  food_court: 'fas fa-utensils',
  // Shopping
  marketplace: 'fas fa-store',
  mall: 'fas fa-shop',
  supermarket: 'fas fa-cart-shopping',
  convenience: 'fas fa-store',
  clothes: 'fas fa-shirt',
  electronics: 'fas fa-laptop',
  jewelry: 'fas fa-gem',
  mobile_phone: 'fas fa-mobile-screen',
  beauty: 'fas fa-spray-can',
  hardware: 'fas fa-wrench',
  stationery: 'fas fa-pen',
  shoes: 'fas fa-shoe-prints',
  greengrocer: 'fas fa-carrot',
  tailor: 'fas fa-scissors',
  car: 'fas fa-car',
  grocery: 'fas fa-shopping-basket',
  furniture: 'fas fa-couch',
  bakery: 'fas fa-bread-slice',
  general: 'fas fa-store',
  hairdresser: 'fas fa-cut',
  medical_supply: 'fas fa-pills',
  // Services
  fuel: 'fas fa-gas-pump',
  police: 'fas fa-shield-halved',
  post_office: 'fas fa-envelope',
  parking: 'fas fa-square-parking',
  charging_station: 'fas fa-charging-station',
  car_wash: 'fas fa-car',
  toll: 'fas fa-road',
  bus_station: 'fas fa-bus',
  internet_cafe: 'fas fa-wifi',
  toilets: 'fas fa-restroom',
  // Facilities
  facility: 'fas fa-warehouse',
  // Tourism
  hotel: 'fas fa-hotel',
  museum: 'fas fa-landmark',
  attraction: 'fas fa-star',
  gallery: 'fas fa-image',
  zoo: 'fas fa-paw',
  viewpoint: 'fas fa-eye',
  hostel: 'fas fa-bed',
  guest_house: 'fas fa-house',
  motel: 'fas fa-hotel',
  resort: 'fas fa-umbrella-beach',
  theme_park: 'fas fa-ferris-wheel',
  aquarium: 'fas fa-fish',
  artwork: 'fas fa-palette',
  // Leisure
  park: 'fas fa-tree',
  fitness_centre: 'fas fa-dumbbell',
  sports_centre: 'fas fa-futbol',
  swimming_pool: 'fas fa-swimming-pool',
  playground: 'fas fa-child',
  stadium: 'fas fa-stadium',
  golf_course: 'fas fa-golf-ball-tee',
  bowling_alley: 'fas fa-bowling-ball',
  cinema: 'fas fa-film',
  theatre: 'fas fa-theater-masks',
  amusement_arcade: 'fas fa-gamepad',
  // Religion
  place_of_worship: 'fas fa-place-of-worship',

  // Other
  pothole: 'fas fa-triangle-exclamation',
  apartment: 'fas fa-building',
  default: 'fas fa-map-marker-alt',
};

// Route Configuration
export const ROUTE_CONFIG = {
  LINE_WIDTH: 4,
  LINE_COLOR: '#007bff',
  LINE_OPACITY: 0.8,
  POINT_A_COLOR: '#00ff00',
  POINT_B_COLOR: '#ff0000',
};

// Animation Durations
export const ANIMATION_DURATIONS = {
  SIDEBAR_CLOSE: 300, // ms
  ZOOM_TO_LOCATION: 1500, // ms
  FLY_TO_DURATION: 2000, // ms
};

// Search Configuration
export const SEARCH_CONFIG = {
  DEBOUNCE_DELAY: 800, // ms
  MIN_QUERY_LENGTH: 2,
};

// Cache Configuration
export const CACHE_CONFIG = {
  POI_TTL: 300000, // 5 minutes
};

